// extracted by mini-css-extract-plugin
module.exports = {"trxnTab":"TransactionTab_trxnTab__F5Lsi","trxnTabPane":"TransactionTab_trxnTabPane__3ONbt","cardContainer":"TransactionTab_cardContainer__3ETQn"};